module.exports = __webpack_public_path__ + "img/einDorNahalTavor.e533b998.png";